import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import UserProfileForm from './../../components/UserProfileForm/UserProfileForm';

class UserProfileDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <UserProfileForm />
      </div>
    );
  }
}

export default withRouter(UserProfileDetails);
